import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, CardHeader, CardBody } from "../Card"
import ToggleSwitch from '../ToggleSwitch'
import actions from '../../actions/index'
import { currentUtcDateTime } from '../../utils/dateTime'

export class PressRoundUpPaddle extends Component {
  state = {
    checked: this.props.defaultChecked
  };

  saveEUPruAlertPreference = (currentEUPruAlert) => {
    const euPruItem = { "id": 1, "name": "EU" }
    this.savePruAlertPreference(euPruItem, currentEUPruAlert)
  }

  saveUSPruAlertPreference = (currentUSPruAlert) => {
    const usPruItem = { "id": 2, "name": "US" }
    this.savePruAlertPreference(usPruItem, currentUSPruAlert)
  }

  savePruAlertPreference = (currentPruItem, currentPruAlert) => {
    let currentPruPreference = this.props.preferences.alertPreferences.find(
      element => element.id == this.props.id
    );
    let itemIndex = currentPruPreference.pressRoundUp.findIndex(x => x.id == currentPruItem.id)
    if (currentPruAlert && itemIndex === -1) {
      currentPruPreference.pressRoundUp.push(currentPruItem)
    }
    if (!currentPruAlert && itemIndex !== -1) {
      currentPruPreference.pressRoundUp.splice(itemIndex, 1)
    }

    let newAlertPreferences = this.props.preferences.alertPreferences.map(
      element => element.id == this.props.id
        ? { ...element, pressRoundUp: currentPruPreference.pressRoundUp, dateModified: currentUtcDateTime() }
        : element
    );

    const request = () => {
      return {
        ...this.props.preferences,
        alertPreferences: newAlertPreferences
      }
    }
    // this.props.alertPreference.pressRoundUp = currentPruPreference.pressRoundUp

    this.props.onSubmit(request())
  }

  render() {
    let euPruSwitchId = `tsEUPruAlert${this.props.id}`
    let usPruSwitchId = `tsUSPruAlert${this.props.id}`    
    let pruTypes = this.props.alertPreference.pressRoundUp.map(element => element.id)
    let euPruAlert = pruTypes.includes(1)
    let usPruAlert = pruTypes.includes(2)

    return (
      <div className={'paddle pru_paddle' + ( euPruAlert || usPruAlert ? ' alert_enabled' : ' alert_disabled') }>
        <Card>
          <CardHeader>
            <span className="pru_paddle_name">{this.props.name}</span>
            <span className="eu_pru_alert">
              <ToggleSwitch id={euPruSwitchId} Name={euPruSwitchId} defaultChecked={euPruAlert} apiCallFunc={this.saveEUPruAlertPreference} text='Europe' 
              datagmupn='personalize'
              datagmuc='alerts'
              datagmue='pressroundup_europetoggle'
              datagmua='click'/>
            </span>
            <span>
              <ToggleSwitch id={usPruSwitchId} Name={usPruSwitchId} defaultChecked={usPruAlert} apiCallFunc={this.saveUSPruAlertPreference} text='United States' 
              datagmupn='personalize'
              datagmuc='alerts'
              datagmue='pressroundup_usatoggle'
              datagmua='click'/>
            </span>
          </CardHeader>
          <CardBody>
            <div className="card_body_row">
              <div className="items_wrapper">
                <span className='category_text'>Receive one email containing a curated list of Antitrust news headlines from third-party news outlets at the start of each weekday. Choose from a European or United States edition.</span>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    preferences: state.userPreferences
  }
}

const mapDispatchToProps = (dispatch) => ({
  onSubmit(request) {
    dispatch(actions.updatePreferences(request))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PressRoundUpPaddle)
